"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaskMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spacingMixin = require("../spacingMixin");
var maskCSS = function maskCSS(props) {
  if (!props.enabled) {
    return '';
  }
  return (0, _styledToken.default)('Mask.backgroundColor', function (backgroundColor) {
    return "\n            position: relative;\n            user-select: none;\n            &:after {\n                content: '';\n                background-color: " + (backgroundColor || '') + ";\n                opacity: 0.5;\n                position: absolute;\n                top: 0;\n                left: 0;\n                height: 100%;\n                width: 100%;\n            }\n        ";
  })(props);
};

/** @class MaskMixin */
/** @method */
var MaskMixin = function MaskMixin(props) {
  return [maskCSS(props), (0, _spacingMixin.spacingMixin)(props)];
};
exports.MaskMixin = MaskMixin;